module.exports = __webpack_public_path__ + "images/interview-Spotify-2.svg";